import { defineAsyncComponent } from "vue";
export default {
    data(){ return {
        icons_lvl: {
            notify: "question",
            success: "check",
            alert: "exclamation",
            warning: "exclamation-triangle",
        },
    }},
    methods: {
        iconLvl(lvl) { 
            return this.hasKey(this.icons_lvl, lvl) ? this.icons_lvl[lvl] : "info"; 
        },
    },
    components: {
        Icon: defineAsyncComponent(() => import(
            /* webpackChunkName: "icon" */
            '@/componentsv2/Icon/'
        )),
    }
}